// extracted by mini-css-extract-plugin
module.exports = {"UserProfileGroupNames":"UserProfilePopover_UserProfileGroupNames__PztOs","userProfileMenu":"UserProfilePopover_userProfileMenu__IjlMf"};